import { isEqual } from 'lodash';

export function isCollectionCriteriaEqual(
  saved: MBAPI.ViewTemplate_collectionCriteria | null,
  updated: MBAPI.ViewTemplate_collectionCriteria | null,
): boolean {
  const isFiltersEqual = isCriterionEqual(saved?.filterByComponents, updated?.filterByComponents);
  const isSortsEqual = isCriterionEqual(saved?.sortByComponents, updated?.sortByComponents);
  const isGroupsEqual = isCriterionEqual(saved?.groups, updated?.groups);

  return isFiltersEqual && isSortsEqual && isGroupsEqual;
}

type CollectionCriterion =
  | MBAPI.ViewTemplate_collectionCriteria_filterByComponents[]
  | MBAPI.ViewTemplate_collectionCriteria_sortByComponents[]
  | MBAPI.ViewTemplate_collectionCriteria_groups[];

function isCriterionEqual<T extends CollectionCriterion>(
  saved: T | null | undefined,
  updated: T | null | undefined,
): boolean {
  return isEqual(saved ?? [], updated ?? []);
}
